__turbopack_context__.v({
  "accountLink": "styles-module-scss-module__b_OEkG__accountLink",
  "banner": "styles-module-scss-module__b_OEkG__banner",
  "captions": "styles-module-scss-module__b_OEkG__captions",
  "dialogCaption": "styles-module-scss-module__b_OEkG__dialogCaption",
  "guestLink": "styles-module-scss-module__b_OEkG__guestLink",
  "link": "styles-module-scss-module__b_OEkG__link",
  "root": "styles-module-scss-module__b_OEkG__root",
  "yellowColor": "styles-module-scss-module__b_OEkG__yellowColor",
});
